import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, OnDestroy, SecurityContext, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataBindingDirective, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { FileRestrictions, SuccessEvent, ErrorEvent } from '@progress/kendo-angular-upload';
import { isNullOrUndefined } from 'util';
import { ClassCodes, ClassCodesListResponse } from '../../../models/classCodes.model';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { ContactUploadFieldMapping, ContactUploadFieldMappingResponse, ContactUploadMoreFilters, LookUpItem, Map_Filter_Item, ProcessStep2Resonse, UploadContactSummary } from '../../../models/contactExcelUpload';
import { eButtonActions, eEditType, eFeatures, eNoteOwnerType, eUploadContactActionToTake, eUserRole } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { UploadCompany, UploadCompanyRespone } from '../../../models/uploadCompany.model';
import { UploadComppanyBulkActionResponse, UploadContactBulkAction, UploadContactBulkActionResponse, UploadContactVM, UploadContactVMResponse } from '../../../models/uploadContacts.model';
import { ClassCodeService } from '../../../services/classCode.service';
import { ContactService } from '../../../services/contact.service';
import { NotificationService } from '../../../services/notification.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { process } from '@progress/kendo-data-query';
import { parseDate } from '@progress/kendo-angular-intl';
import { UploadMapping, UploadMappingResponse } from '../../../models/uploadMapping.model';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from '../../../services/global.service';
import { EHOSTUNREACH } from 'constants';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { IntDropDownItem, SimpleResponse } from '../../../models/genericResponse.model';
import { isNullOrEmptyString } from '../../../../shared/utils';
import { UserService } from '../../../services/user.service';
import { TagsFields } from '../../../models/tag-settings.model';
import { TagSettingService } from '../../../services/tag-setting.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

declare var $: any;

@Component({
    selector: 'app-contact-upload-excel',
    templateUrl: './contact-upload-excel.component.html',
    styleUrls: ['./contact-upload-excel.component.css'],
    providers: [{ provide: 'GridConfigurationService', useClass: GridConfigurationService },
    { provide: 'GridConfigurationService1', useClass: GridConfigurationService }]
})
export class ContactUploadExcelComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    private intervals = new Set<ReturnType<typeof setInterval>>();

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    //@ViewChild('paginator') paginator!: MatPaginator;
    contactSource: MatTableDataSource<any>;
    contactDisplayColumns: string[];
    companySource: MatTableDataSource<any>;
    companyDisplayColumns: string[];
    eUserRole = eUserRole;
    private encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    showSpinner: boolean = false;
    step: number = 1;
    classCodes: ClassCodes[] = [];
    groupByClassCode: Map<string, ClassCodes[]>;
    contactSheets = [];
    sheetSelected;
    showWorkSheet;
    confirmMessage: string;
    stepTwoMessage: string;
    contactUploadFieldMapResponse: ContactUploadFieldMappingResponse;
    contactUploadFieldMappings: ContactUploadFieldMapping;
    excelFileName: any;
    sheetSelectedData: any[];
    sheetSelectedValue: string;
    lookUpNoteTypeCode: Map_Filter_Item[];
    lookUpFields: LookUpItem[];
    lookUpExistingMappings: LookUpItem[];
    contactUploadForm = new FormGroup({});
    useLastName: boolean = false;
    cbContactID: boolean = false;
    isFindDuplicate: boolean = false;
    addMapComments: any = [];
    historyEntry: any[] = [];
    baseUrl: string;
    selectedNames: [] = [];
    uploadSessionId: number;
    processStep2Resonse: ProcessStep2Resonse;
    uploadContactSummary: UploadContactSummary;
    isEditField: boolean = false;
    uploadEditFieldForm: FormGroup;
    step4Message: string = "";

    isProcessedListContacts: boolean = false;
    public mySelection: number[] = [];
    public contactsUploaded: number[] = [];
    public companySelection: number[] = [];
    selectAllContacts: boolean = false;
    DuplicateContactenum: number = 0;
    DuplicateCompanyenum: number = 0;
    /* grid*/

    columns = [
        { field: '$', title: ' ', width: '40' },
        { field: 'name', title: 'Name', width: '250' },
        { field: 'address', title: 'Address', width: '250' },
        { field: 'email', title: 'Email', width: '80' },
        { field: 'classification', title: 'Classification', width: '80' },
        { field: 'owner', title: 'Owner', width: '80' },
        { field: 'systemNote', title: 'System Message', width: '60' },
        { field: 'actionToTake', title: 'Action', width: '140' },
        { field: 'action', title: '', width: '140' },
    ];
    reorderColumnName: string = 'name,address,email,classification,owner,systemNote,actionToTake';
    columnWidth: string = 'name:250,address:250,email:70,classification:250,owner:120,systemNote:120,actionToTake:120';
    arrColumnWidth: any[] = ['name:250,address:250,email:70,classification:250,owner:120,systemNote:120,actionToTake:120'];
    gridHeight;
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    isDuplicateContact: boolean = false;
    isDuplicateCompany: boolean = false;
    contactProcessedList: UploadContactVM[] = [];
    initContactProcessedList: UploadContactVM[] = [];
    contactDuplicateList: UploadContactVM[];
    initContactDuplicateList: UploadContactVM[];
    /* grid*/

    /* grid Company*/

    columnsCmp = [
        { field: '$', title: ' ', width: '40' },
        { field: 'companyName', title: 'Company', width: '250' },
        { field: 'addressDisplay', title: 'Address', width: '250' },
        { field: 'webSite', title: 'Website', width: '70' },
        { field: 'clpUserDisplay', title: 'Created By', width: '250' },
        { field: 'systemNote', title: 'System Message', width: '120' },
        { field: 'actionToTake', title: 'Action', width: '120' },
        { field: 'action', title: '', width: '120' },
    ];

    reorderColumnNameCmp: string = 'companyName,addressDisplay,webSite,clpUserDisplay,systemNote,actionToTake';
    columnWidthCmp: string = 'companyName:250,addressDisplay:250,webSite:70,clpUserDisplay:250,systemNote:120,actionToTake:120';
    arrColumnWidthCmp: any[] = ['companyName:250,addressDisplay:250,webSite:70,clpUserDisplay:250,systemNote:120,actionToTake:120'];
    @ViewChild(DataBindingDirective) dataBindingCmp: DataBindingDirective;
    isDuplicateContactCmp: boolean = false;
    companyDuplicateList: UploadCompany[];
    initCompanyDuplicateList: UploadCompany[];
    companyProcessedList: UploadCompany[];
    initCompanyProcessedList: UploadCompany[];
    /* grid Company*/

    uploadContactVMResponse: UploadContactVMResponse;
    private masterList: UploadContactVM[] = [];
    messageStep3: string = "";
    editMode: boolean = false;
    /*enums*/
    enumForEditType;
    editTypeKeys: unknown[];
    initEditTypeKeys: unknown[];
    enumActionToTake;
    /*enums*/
    classCode: ClassCodes[];
    tagList: LookUpItem[];
    tagData: LookUpItem[];
    /**/

    searchScopeList: { value: number; text: string; }[] = [];
    messageTransfer: string = "Please select the new owner of all checked contacts.";
    isToTransferFieldContact = '0';
    filterManagerTransfer: LookUpItem[];
    newManagerId: string = '';
    searchScope: number;
    DupItemVal: number = 0;
    processGridType: number = 0;
    configuregrid: number = 0;
    uploadMappingID: number;
    uploadCompanyResponse: UploadCompanyRespone;
    reUploadMappingFields: UploadMapping;
    messageToShowAfter: string;
    transferConfirmation: boolean = true;
    saveConfirmation: boolean = false;
    loadStep4: boolean = false;
    step4Complete: boolean = false;
    mobileColumnNames: string[];
    mobileCompanyColumnNames: string[];
    buttonTypeOperation: eButtonActions = eButtonActions.None;
    totalContactsUploaded: number = 0
    disableBtn: boolean;
    adminOptIn: boolean
    adminEmailSubscription: boolean
    ddOptinText: string = "Ignore"
    ddSubscribeEmail: string = "Ignore"
    showalert: string;
    uploadSaveUrl: string;
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: [".xlsx"],
        maxFileSize: 10485760
    };
    fileUploadHeaders: HttpHeaders;
    companyData: ClpCompany;
    userTeamDisplay: string;
    userOfficeDisplay: string;
    listTeamCodes: IntDropDownItem[] = [];
    listOfficeCodes: IntDropDownItem[] = [];
    isSearchScopeDD: boolean = true;
    isDupItemsDD: boolean = false;
    ddDupItems: IntDropDownItem[] = [];
    showCompanyCustomFields: boolean = false;
    mapCommentsDDOpen: boolean = false;
    historyEntryDDOpen: boolean = false;
    totContactsToUpload: string;
    totCompaniesToUpload: string;
    warningMsg: string = "Please select the new owner of all selected contacts.";
    tranferStep: number = 0;
    isShowContactDuplicatebtn: boolean = false;
    isShowCompaniesDuplicatebtn: boolean = false;
    noteTypeCode: number = 0;
    constructor(public _localService: LocalService, @Inject('BASE_URL') _baseUrl: string,
        public _userService: UserService,
        public _contactService: ContactService,
        private _tagSettingService: TagSettingService,
        public _classCodeService: ClassCodeService, private fb: FormBuilder, private _utilityService: UtilityService, private _notifyService: NotificationService, private _sanitizer: DomSanitizer,
        @Inject('GridConfigurationService') public _gridCnfgService: GridConfigurationService,
        @Inject('GridConfigurationService1') public _gridCnfgServiceCompany: GridConfigurationService, public _globalService: GlobalService,
        private _router: Router,
        public _accountSetupService: AccountSetupService,
    ) {
        this.gridHeight = this._localService.getGridHeight('432px');
        this._localService.isMenu = true;
        this.baseUrl = _baseUrl;
    }

    apiResponseSuccess(event: SuccessEvent) {
        if (!isNullOrUndefined(event)) {
            this.contactSheets = event?.response?.body?.list;
            if (this.contactSheets?.length > 0) {
                this.sheetSelected = this.contactSheets[0]?.key;
            }
            this.showWorkSheet = true;
            this.adminOptIn = true;
            this.showalert = '';
            this.adminEmailSubscription = true
            this.confirmMessage = event?.response?.body?.messageString;
            this.excelFileName = event?.response?.body?.messageString2;
            //this._notifyService.showSuccess("File uploaded successfully.", "Success", 3000)
        }
    }

    apiResponseError(e) {
        if (!isNullOrUndefined(e)) {
            this._notifyService.showError(`Error in uploading file : ${e.files[0].name}`, "", 2000);
        }
    }
    ngOnInit() {

        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.getCompanyByCompanyId();
                        this.getExcelUploadData();
                        this.getDefaultNoteType();
                        this.showalert = '';
                        this.newManagerId = this.user.cLPUserID.toString();
                        this.fileUploadHeaders = new HttpHeaders({
                            'Authorization': 'Basic ' + this.encryptedUser
                        });
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });

    }
    async getDefaultNoteType() {
        await this._userService.getCodeByDisplay(this.encryptedUser, 800, this.user.cLPCompanyID, 'Note')
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.noteTypeCode = response.messageInt;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-upload-excel.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.ExcelUploadWizard)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-upload-excel.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }


    groupBy<K, V>(array: V[], grouper: (item: V) => K) {
        return array.reduce((store, item) => {
            var key = grouper(item)
            if (!store.has(key)) {
                store.set(key, [item])
            } else {
                store.get(key).push(item)
            }
            return store
        }, new Map<K, V[]>())
    }

    async getExcelUploadData() {
        this.getUploadExcelConfig();
        this.showSpinner = true;
        await this._classCodeService.getClassCodes(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: ClassCodesListResponse) => {
                if (result) {
                    this.classCodes = UtilityService.clone(result.classCodes);
                    for (var i = 0; i < this.classCodes.length; i++) {
                        this.classCodes[i].key = this.classCodes[i].tableName + " : " + this.classCodes[i].classCodeTitle;
                    }
                    this.groupByClassCode = this.groupBy(this.classCodes, x => x.key);
                    this.getUploadExcelConfig();
                    this.showSpinner = false;
                }
                else {
                    this.showSpinner = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    getSheetSelectedName() {
        if (!isNullOrUndefined(this.sheetSelected)) {
            this.sheetSelectedData = this.contactSheets?.filter(data => data.key == this.sheetSelected);
            this.sheetSelectedValue = this.sheetSelectedData[0].value;
        }
    }
    uploadFailHandle() {
        this.step = 1;
        this.contactSheets = null;
        this.sheetSelected = null;
        this.showWorkSheet = false;
        this.confirmMessage = null;
        this.excelFileName = null;

    }
    async contactUploadStep1() {
        this.getSheetSelectedName();
        if (isNullOrUndefined(this.sheetSelectedValue)) {
            this._notifyService.showError('Could not find the Uploaded File', '', 3000);
            this.uploadFailHandle();
        }
        else {
            this.disableBtn = true
            this.buttonTypeOperation = eButtonActions.Save;
            await this._contactService.contactUploadProcessStep1(this.encryptedUser, this.excelFileName, this.user.cLPCompanyID, this.user.cLPUserID, this.sheetSelectedValue)
                .then(async (result: ContactUploadFieldMappingResponse) => {
                    if (result) {
                        this.contactUploadFieldMapResponse = UtilityService.clone(result);
                        this.contactUploadFieldMappings = this.contactUploadFieldMapResponse.contactUploadFieldMappings;
                        this.uploadSessionId = this.contactUploadFieldMapResponse.uploadSessionId;

                        this.userTeamDisplay = this.contactUploadFieldMapResponse.userTeamDisplay;
                        this.userOfficeDisplay = this.contactUploadFieldMapResponse.userOfficeDisplay;
                        this.listTeamCodes = this.contactUploadFieldMapResponse.listTeamCodes;
                        this.listOfficeCodes = this.contactUploadFieldMapResponse.listOfficeCodes;

                        this.disableBtn = false
                        this.buttonTypeOperation = eButtonActions.None;
                        if (!isNullOrUndefined(this.contactUploadFieldMappings))
                            this.contactMappingView();
                        else {
                            this._notifyService.showError('Could Not get File data', '', 3000);
                            this.uploadFailHandle();
                        }
                    }
                    else
                        this.disableBtn = false
                    this.buttonTypeOperation = eButtonActions.None;

                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.disableBtn = false
                    this.buttonTypeOperation = eButtonActions.None;
                    this._utilityService.handleErrorResponse(err);
                });
        }

    }

    copyValueFromContactUploadFormToData() {
        this.copyObjectBeforeSave();
        this.contactUploadFieldMappings.mapAdd1.fieldValue = this.contactUploadForm.controls['mapAdd1'].value;
        this.contactUploadFieldMappings.mapAdd2.fieldValue = this.contactUploadForm.controls['mapAdd2'].value;
        this.contactUploadFieldMappings.mapAdd3.fieldValue = this.contactUploadForm.controls['mapAdd3'].value;
        this.contactUploadFieldMappings.mapAltPhone.fieldValue = this.contactUploadForm.controls['mapAltPhone'].value;
        this.contactUploadFieldMappings.mapCity.fieldValue = this.contactUploadForm.controls['mapCity'].value;
        this.contactUploadFieldMappings.mapComments.fieldValue = this.contactUploadForm.controls['mapComments'].value.toString();
        this.contactUploadFieldMappings.mapHistory.fieldValue = this.contactUploadForm.controls['mapHistory'].value.toString();
        this.contactUploadFieldMappings.mapCompany.fieldValue = this.contactUploadForm.controls['mapCompany'].value;
        this.contactUploadFieldMappings.mapCountry.fieldValue = this.contactUploadForm.controls['mapCountry'].value;
        this.contactUploadFieldMappings.mapCustomDate1.fieldValue = this.contactUploadForm.controls['mapCustomDate1'].value;
        this.contactUploadFieldMappings.mapCustomDate1Title.fieldValue = this.contactUploadForm.controls['mapCustomDate1Title'].value;
        this.contactUploadFieldMappings.mapCustomDate2.fieldValue = this.contactUploadForm.controls['mapCustomDate2'].value;
        this.contactUploadFieldMappings.mapCustomDate2Title.fieldValue = this.contactUploadForm.controls['mapCustomDate2Title'].value;
        this.contactUploadFieldMappings.mapCustomDate3.fieldValue = this.contactUploadForm.controls['mapCustomDate3'].value;
        this.contactUploadFieldMappings.mapCustomDate3Title.fieldValue = this.contactUploadForm.controls['mapCustomDate3Title'].value;
        this.contactUploadFieldMappings.mapCustomDate4.fieldValue = this.contactUploadForm.controls['mapCustomDate4'].value;
        this.contactUploadFieldMappings.mapCustomDate4Title.fieldValue = this.contactUploadForm.controls['mapCustomDate4Title'].value;
        this.contactUploadFieldMappings.mapCustomDate5.fieldValue = this.contactUploadForm.controls['mapCustomDate5'].value;
        this.contactUploadFieldMappings.mapCustomDate5Title.fieldValue = this.contactUploadForm.controls['mapCustomDate5Title'].value;
        this.contactUploadFieldMappings.mapCustomText1.fieldValue = this.contactUploadForm.controls['mapCustomText1'].value;
        this.contactUploadFieldMappings.mapCustomText2.fieldValue = this.contactUploadForm.controls['mapCustomText2'].value;
        this.contactUploadFieldMappings.mapCustomText3.fieldValue = this.contactUploadForm.controls['mapCustomText3'].value;
        this.contactUploadFieldMappings.mapCustomText4.fieldValue = this.contactUploadForm.controls['mapCustomText4'].value;
        this.contactUploadFieldMappings.mapCustomText5.fieldValue = this.contactUploadForm.controls['mapCustomText5'].value;
        this.contactUploadFieldMappings.mapEmail.fieldValue = this.contactUploadForm.controls['mapEmail'].value;
        this.contactUploadFieldMappings.mapEmail2.fieldValue = this.contactUploadForm.controls['mapEmail2'].value;
        this.contactUploadFieldMappings.mapEmail3.fieldValue = this.contactUploadForm.controls['mapEmail3'].value;
        this.contactUploadFieldMappings.mapFax.fieldValue = this.contactUploadForm.controls['mapFax'].value;
        this.contactUploadFieldMappings.mapFirstName.fieldValue = this.contactUploadForm.controls['mapFirstName'].value;
        this.contactUploadFieldMappings.mapHistoryNotes.fieldValue = this.contactUploadForm.controls['mapHistoryNotes'].value;
        this.contactUploadFieldMappings.mapHomePhone.fieldValue = this.contactUploadForm.controls['mapHomePhone'].value;
        this.contactUploadFieldMappings.mapLastName.fieldValue = this.contactUploadForm.controls['mapLastName'].value ?? "";
        this.contactUploadFieldMappings.mapTags.fieldValue = this.contactUploadForm.controls['mapTags'].value ?? "";
        this.contactUploadFieldMappings.mapMobile.fieldValue = this.contactUploadForm.controls['mapMobile'].value;
        this.contactUploadFieldMappings.mapNotes.fieldValue = this.contactUploadForm.controls['mapNotes'].value;
        this.contactUploadFieldMappings.mapOtherFax.fieldValue = this.contactUploadForm.controls['mapOtherFax'].value;
        this.contactUploadFieldMappings.mapSalutation.fieldValue = this.contactUploadForm.controls['mapSalutation'].value;
        this.contactUploadFieldMappings.mapShare.fieldValue = this.contactUploadForm.controls['mapShare'].value;
        this.contactUploadFieldMappings.mapState.fieldValue = this.contactUploadForm.controls['mapState'].value;
        this.contactUploadFieldMappings.mapTitle.fieldValue = this.contactUploadForm.controls['mapTitle'].value;
        this.contactUploadFieldMappings.mapUserCode.fieldValue = this.contactUploadForm.controls['mapUserCode'].value;
        this.contactUploadFieldMappings.mapWebSite.fieldValue = this.contactUploadForm.controls['mapWebSite'].value;
        this.contactUploadFieldMappings.mapZip.fieldValue = this.contactUploadForm.controls['mapZip'].value;
        /*    this.contactUploadFieldMappings.mapcompanyClass1.fieldValue = this.contactUploadForm.controls['mapAdd1'].mapcompanyClass1.value;*/
        this.contactUploadFieldMappings.mapdtCreated.fieldValue = this.contactUploadForm.controls['mapdtCreated'].value;
        this.contactUploadFieldMappings.mapdtLastModified.fieldValue = this.contactUploadForm.controls['mapdtLastModified'].value;
        this.contactUploadFieldMappings.phone.fieldValue = this.contactUploadForm.controls['phone'].value;
        this.contactUploadFieldMappings.mapWebSite.fieldValue = this.contactUploadForm.controls['mapWebSite'].value;
        this.contactUploadFieldMappings.mappingName = this.contactUploadForm.controls['mappingName'].value;
        if (this.cbContactID)
            this.contactUploadFieldMappings.cbContactID.fieldValue = this.contactUploadForm.controls['cbContactID'].value;

    }

    async contactUploadFormSubmit() {

        var Selected = false;
        Object.keys(this.contactUploadForm.controls).forEach(field => {
            var control = this.contactUploadForm.get(field);
            if ((field == "mapLastName" || field == "mapFirstName" || field == "mapCompanyName" || field == "mapEmail") && Selected == false) {

                if (String(control.value) != "") {
                    if (!isNaN(Number(control.value))) {
                        Selected = true;
                    }

                }


            }

        });

        if (Selected == false) {
            this._notifyService.showError("At Least one of the fields, First Name, Last Name, Company Name, or Email must be mapped to a field.", "", 3000);
        }
        else {

            this._localService.validateAllFormFields(this.contactUploadForm);
            if (this.contactUploadForm.valid) {
                this.contactUploadForm.markAsPristine();
                await this.updateContactUploadFormStep2();
            }
            else
                this._notifyService.showError("Invalid Excel Upload Fields", "", 3000);
        }

    }
    async updateContactUploadFormStep2() {
        this.copyValueFromContactUploadFormToData();
        if (!isNullOrUndefined(this.uploadSessionId))
            await this.contactUploadStep2();
        else {
            await this.contactUploadStep1();
            this._notifyService.showError('Could not find the upload Session', 2000);
        }

    }

    async contactUploadStep2() {
        this.disableBtn = true;
        await this._contactService.contactUploadProcessStep2(this.encryptedUser, this.user.cLPUserID, this.uploadSessionId, this.user.cLPCompanyID, this.excelFileName, this.sheetSelectedValue, 0, this.contactUploadFieldMappings)
            .then(async (result: ProcessStep2Resonse) => {
                if (result) {
                    this.processStep2Resonse = UtilityService.clone(result);
                    this.uploadContactSummary = this.processStep2Resonse.uploadContactSummary;
                    this.totContactsToUpload = this.uploadContactSummary?.totNewContacts;
                    this.totCompaniesToUpload = this.uploadContactSummary?.totNewCompanies;
                    this.checkContactCompany();
                    if (!isNullOrUndefined(this.processStep2Resonse.uploadContactSummary.messageString))
                        this.step4Message = this.processStep2Resonse.uploadContactSummary.messageString;

                    this.uploadMappingID = this.processStep2Resonse.uploadMappingID;
                    if (!isNullOrEmptyString(this.uploadContactSummary.totExistingContacts)) {
                        let totExistingContacts = +this.uploadContactSummary.totExistingContacts
                        if (totExistingContacts <= 5) {
                            this.isFindDuplicate = false;
                        }
                        else {
                            if (this.uploadContactSummary.dupCheck) {
                                this.isFindDuplicate = false;
                            }
                            else {
                                this.isFindDuplicate = true;
                            }
                        }
                    }
                    this.step = 3;
                    this.searchScope = 0;
                    this.editField();
                    this.contactUploadGetMoreFilters();
                    this.contactGetListProcessed();
                    this.companiesListProcessed();
                    this.companiesListDuplicate();
                    this.contactGetListDuplicate();
                    this.commonEditTypeForm();
                    this.disableBtn = false;
                }
                else
                    this.disableBtn = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.disableBtn = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    contactMappingView() {
        this.contactUploadFieldMappings.cbContactID ? this.cbContactID = true : this.cbContactID = false;
        this.lookUpNoteTypeCode = this.contactUploadFieldMapResponse.lookUp_NoteTypecode;
        this.lookUpExistingMappings = this.contactUploadFieldMapResponse.lookUp_ExistingMappings;
        this.lookUpFields = this.contactUploadFieldMapResponse.lookUp_fields;
        this.step = 2;
        this.stepTwoMessage = this.contactUploadFieldMapResponse.messageString;
        if (!isNullOrUndefined(this.contactUploadFieldMappings))
            this.contactUploadFieldMappings.mappingName = "";
        this.removeNullProperties(this.contactUploadFieldMappings);
        if (!isNullOrUndefined(this.contactUploadFieldMappings)) {
            this.setValidation();
            this.patchContactUploadFormValue();
            this.updateDataContacts();
            this.renderLastName();
        }
    }

    renderLastName() {
        this.contactUploadForm.controls["splitFirstName"].valueChanges.pipe(takeUntil(this.destroy$)).subscribe(name => {
            this.useLastName = name;
        });
    }
    updateDataContacts() {
        Object.keys(this.contactUploadForm.controls).forEach(key => {
            var handleMappingkeys = ["splitFirstName", "mapHistoryNotes", "cbContactID", "mappingName"]
            if (!handleMappingkeys.includes(key))
                this.iterateAndSubControls(key);
        });
    }
    setValidation() {
        var conatactsUploadFields = this.contactUploadFieldMappings;
        for (let key in conatactsUploadFields) {
            let value = conatactsUploadFields[key];
            if (!isNullOrUndefined(value))
                this.prepareContactUploadForm(key, value);
        }
    }
    private prepareContactUploadForm(key, value) {
        this.contactUploadForm.addControl(key, new FormControl(key == 'splitFirstName' ? false : ''))
    }

    patchContactUploadFormValue() {
        var conatactsUploadFields = this.contactUploadFieldMappings;
        for (let key in conatactsUploadFields) {

            if (key == 'cbContactID' || key == 'splitFirstName') {
                key == 'cbContactID' ? this.preparePatchContactFormValue(key, true) : this.preparePatchContactFormValue(key, false);
            }
            else {
                let value = conatactsUploadFields[key];
                if (!isNullOrUndefined(value)) {
                    let items: Map_Filter_Item[] = value.items;
                    let selectedItems = items?.filter(val => val.isselected == true);
                    if (!isNullOrUndefined(selectedItems) && selectedItems.length >= 1) {
                        selectedItems.length == 1 ? value.fieldValue = selectedItems[0].value : console.log(value);
                    }
                }
                if (key == 'mapNotes') {
                    this.noteTypeCode > 0 ? this.preparePatchContactFormValue(key, this.noteTypeCode) : this.preparePatchContactFormValue(key, value);
                }
                else {
                    this.preparePatchContactFormValue(key, value);
                }
            }
        }
    }

    iterateAndSubControls(formKey: string) {
        this.contactUploadForm.controls[formKey].valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
            this.contactUploadFieldMappings[formKey].fieldValue = val;
            this.contactUploadFieldMappings[formKey].items.forEach(value => {
                if (value.value === val)
                    value.isselected = true;
                else
                    value.isselected = false;
            })

        }
        );
    }

    preparePatchContactFormValue(key, value) {
        if (key == 'cbContactID' || key == 'splitFirstName' || key == 'mappingName' || (key == 'mapNotes' && value > 0)) {
            this.contactUploadForm.get(key).setValue(value);
        }
        else if (key == 'mapComments') {
            this.contactUploadForm.get(key).setValue([value.fieldValue]);
            this.addMapComments = [value.fieldValue];
            this.mapCommentsDDOpen = true;
        }
        else {
            this.contactUploadForm.get(key).setValue(value.fieldValue);
        }
    }


    recentUpload: number = 0;

    public async onValueChangeMulti(value, type) {
        switch (type) {
            case 'historyEntry':
                this.historyEntry = value;
                this.historyEntryDDOpen = true;
                break;
            case 'mapComments':
                this.addMapComments = value;
                this.mapCommentsDDOpen = true;
                break;
            case 'recentUploads':
                this.reUploadMapping(this.recentUpload);
                break;
            case 'deleteMap':
                //this.recentUpload = 0;
                await this.uploadMapping_Delete(this.recentUpload)
                this.contactUploadForm.reset();
                this.patchContactUploadForm();
                break;
            default:
                break;
        }
    }

    onClose(event, type) {
        switch (type) {
            case 'historyEntry':
                if (this.historyEntryDDOpen) {
                    event?.preventDefault();
                }
                this.historyEntryDDOpen = false;
                break;
            case 'mapComments':
                if (this.mapCommentsDDOpen) {
                    event?.preventDefault();
                }
                this.mapCommentsDDOpen = false;
                break;
            default:
                break;
        }
    }

    patchContactUploadForm() {
        var contactuploadForm = this.contactUploadForm.controls;
        for (let key in contactuploadForm) {
            if (!(key == 'mappingName' || key == 'splitFirstName' || key == 'mapHistoryNotes' || key == 'cbContactID' || key == 'mapComments' || key == 'mapHistory')) {
                this.contactUploadForm.get(key).setValue('');
            }
        }
    }

    async reUploadMapping(recentUpload: number) {

        this.showSpinner = true;
        await this._contactService.uploadMappingLoad(this.encryptedUser, recentUpload)
            .then(async (result: UploadMappingResponse) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    this.reUploadMappingFields = res.UploadMapping;
                    this.showSpinner = false;
                    this.rePatchContactUploadFormValue();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
    rePatchContactUploadFormValue() {
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.add1);
        this.contactUploadForm.controls['mapAdd2']?.setValue(this.reUploadMappingFields.add2);
        this.contactUploadForm.controls['mapAdd3']?.setValue(this.reUploadMappingFields.add3);
        this.contactUploadForm.controls['mapAltPhone']?.setValue(this.reUploadMappingFields.altPhone);
        this.contactUploadForm.controls['check1']?.setValue(this.reUploadMappingFields.check1);
        this.contactUploadForm.controls['check2']?.setValue(this.reUploadMappingFields.check2);
        this.contactUploadForm.controls['check3']?.setValue(this.reUploadMappingFields.check3);
        this.contactUploadForm.controls['check4']?.setValue(this.reUploadMappingFields.check4);
        this.contactUploadForm.controls['check5']?.setValue(this.reUploadMappingFields.check5);
        this.contactUploadForm.controls['check6']?.setValue(this.reUploadMappingFields.check6);

        this.contactUploadForm.controls['mapCity']?.setValue(this.reUploadMappingFields.city);
        this.contactUploadForm.controls['mapClass1Code']?.setValue(this.reUploadMappingFields.class1Code);
        this.contactUploadForm.controls['mapClass2Code']?.setValue(this.reUploadMappingFields.class2Code);
        this.contactUploadForm.controls['mapClass3Code']?.setValue(this.reUploadMappingFields.class3Code);
        this.contactUploadForm.controls['mapClass4Code']?.setValue(this.reUploadMappingFields.class4Code);
        this.contactUploadForm.controls['mapClass5Code']?.setValue(this.reUploadMappingFields.class5Code);
        this.contactUploadForm.controls['mapClass6Code']?.setValue(this.reUploadMappingFields.class6Code);
        this.contactUploadForm.controls['mapClass7Code']?.setValue(this.reUploadMappingFields.class7Code);
        this.contactUploadForm.controls['mapClass8Code']?.setValue(this.reUploadMappingFields.class8Code);

        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coCheck1);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coCheck2);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coCheck3);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coCheck4);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass1Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass2Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass3Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass4Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass5Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass6Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass7Code);
        this.contactUploadForm.controls['mapAdd1']?.setValue(this.reUploadMappingFields.coClass8Code);

        /*this.contactUploadForm.controls['mapAdd1'].mapcompanyCustom1.setValue(this.reUploadMappingFields.coCustom1);   missing value*/
        this.contactUploadForm.controls['mapcompanyCustom2']?.setValue(this.reUploadMappingFields.coCustom2);
        this.contactUploadForm.controls['mapcompanyCustom3']?.setValue(this.reUploadMappingFields.coCustom3);
        this.contactUploadForm.controls['mapcompanyCustom4']?.setValue(this.reUploadMappingFields.coCustom4);
        this.contactUploadForm.controls['mapcompanyCustom5']?.setValue(this.reUploadMappingFields.coCustom5);
        this.contactUploadForm.controls['mapcompanyCustom6']?.setValue(this.reUploadMappingFields.coCustom6);
        this.contactUploadForm.controls['mapcompanyCustom7']?.setValue(this.reUploadMappingFields.coCustom7);
        this.contactUploadForm.controls['mapcompanyCustom8']?.setValue(this.reUploadMappingFields.coCustom8);

        this.contactUploadForm.controls['mapComments']?.setValue(this.reUploadMappingFields.comments != '' ? this.reUploadMappingFields.comments.split(',').map(Number) : []);
        this.contactUploadForm.controls['mapHistoryNotes']?.setValue(this.reUploadMappingFields.historyNote != '' ? this.reUploadMappingFields.historyNote.split(',').map(Number) : []);
        /*check*/
        this.contactUploadForm.controls['mapCompany']?.setValue(this.reUploadMappingFields.companyName);
        this.contactUploadForm.controls['mapCompanyCustom1']?.setValue(this.reUploadMappingFields.companyName);
        /*check*/
        this.contactUploadForm.controls['mapCountry']?.setValue(this.reUploadMappingFields.country);
        this.contactUploadForm.controls['mapcustom1']?.setValue(this.reUploadMappingFields.custom1);
        this.contactUploadForm.controls['mapcustom2']?.setValue(this.reUploadMappingFields.custom2);
        this.contactUploadForm.controls['mapcustom3']?.setValue(this.reUploadMappingFields.custom3);
        this.contactUploadForm.controls['mapcustom4']?.setValue(this.reUploadMappingFields.custom4);
        this.contactUploadForm.controls['mapcustom5']?.setValue(this.reUploadMappingFields.custom5);
        this.contactUploadForm.controls['mapcustom6']?.setValue(this.reUploadMappingFields.custom6);

        this.contactUploadForm.controls['mapCustomDate1']?.setValue(this.reUploadMappingFields.customDate1);
        this.contactUploadForm.controls['mapCustomDate1Title']?.setValue(this.reUploadMappingFields.customDate1Title);
        this.contactUploadForm.controls['mapCustomDate2']?.setValue(this.reUploadMappingFields.customDate2);
        this.contactUploadForm.controls['mapCustomDate2Title']?.setValue(this.reUploadMappingFields.customDate2Title);
        this.contactUploadForm.controls['mapCustomDate3']?.setValue(this.reUploadMappingFields.customDate3);
        this.contactUploadForm.controls['mapCustomDate3Title']?.setValue(this.reUploadMappingFields.customDate3Title);
        this.contactUploadForm.controls['mapCustomDate4']?.setValue(this.reUploadMappingFields.customDate4);
        this.contactUploadForm.controls['mapCustomDate4Title']?.setValue(this.reUploadMappingFields.customDate4Title);
        this.contactUploadForm.controls['mapCustomDate5']?.setValue(this.reUploadMappingFields.customDate5);
        this.contactUploadForm.controls['mapCustomDate5Title']?.setValue(this.reUploadMappingFields.customDate5Title);
        this.contactUploadForm.controls['mapCustomText1']?.setValue(this.reUploadMappingFields.customText1);
        this.contactUploadForm.controls['mapCustomText2']?.setValue(this.reUploadMappingFields.customText2);
        this.contactUploadForm.controls['mapCustomText3']?.setValue(this.reUploadMappingFields.customText3);
        this.contactUploadForm.controls['mapCustomText4']?.setValue(this.reUploadMappingFields.customText4);
        this.contactUploadForm.controls['mapCustomText5']?.setValue(this.reUploadMappingFields.customText5);

        this.contactUploadForm.controls['mapdtCreated']?.setValue(this.reUploadMappingFields.dateCreated);
        this.contactUploadForm.controls['mapdtLastModified']?.setValue(this.reUploadMappingFields.dateModified);
        /* this.contactUploadForm.controls['mapAdd1'].mapdtCreated?.setValue(this.reUploadMappingFields.dtCreated); not nedeed*/

        this.contactUploadForm.controls['mapEmail']?.setValue(this.reUploadMappingFields.email);
        this.contactUploadForm.controls['mapEmail2']?.setValue(this.reUploadMappingFields.email2);
        this.contactUploadForm.controls['mapEmail3']?.setValue(this.reUploadMappingFields.email3);
        this.contactUploadForm.controls['mapFax']?.setValue(this.reUploadMappingFields.fax);
        this.contactUploadForm.controls['mapFirstName']?.setValue(this.reUploadMappingFields.firstName);
        this.contactUploadForm.controls['mapHistoryNotes']?.setValue(this.reUploadMappingFields.historyNote);
        this.contactUploadForm.controls['mapHomePhone']?.setValue(this.reUploadMappingFields.homePhone);
        this.contactUploadForm.controls['mapLastName']?.setValue(this.reUploadMappingFields.lastName);
        this.contactUploadForm.controls['mapTags']?.setValue(this.reUploadMappingFields.lastName);
        this.contactUploadForm.controls['mappingName']?.setValue(this.reUploadMappingFields.mappingName);
        this.contactUploadForm.controls['mapMobile']?.setValue(this.reUploadMappingFields.mobile);

        this.contactUploadForm.controls['mapNotes']?.setValue(this.reUploadMappingFields.mapNotes);

        this.contactUploadForm.controls['mapSalutation']?.setValue(this.reUploadMappingFields.salutation);
        this.contactUploadForm.controls['mapOtherFax']?.setValue(this.reUploadMappingFields.otherFax);
        this.contactUploadForm.controls['mapShare']?.setValue(this.reUploadMappingFields.shareable);
        this.contactUploadForm.controls['splitFirstName']?.setValue(this.reUploadMappingFields.splitFirstName);
        this.contactUploadForm.controls['mapState']?.setValue(this.reUploadMappingFields.state);
        this.contactUploadForm.controls['mapTitle']?.setValue(this.reUploadMappingFields.title);
        this.contactUploadForm.controls['mapUserCode']?.setValue(this.reUploadMappingFields.userCode);
        this.contactUploadForm.controls['mapWebSite']?.setValue(this.reUploadMappingFields.webSite);
        this.contactUploadForm.controls['mapZip']?.setValue(this.reUploadMappingFields.zip);

    }

    copyObjectBeforeSave() {
        if (!isNullOrUndefined(this.contactUploadFieldMappings.mapHistoryNotes.items)) {
            this.contactUploadFieldMappings.mapHistoryNotes.items.filter(element => {
                this.historyEntry.forEach(historyValue => {
                    if (historyValue == element.value)
                        element.isselected = true;
                })
            });
        }
        if (!isNullOrUndefined(this.contactUploadFieldMappings.mapComments.items)) {
            this.contactUploadFieldMappings.mapComments.items.filter(element => {
                this.addMapComments.forEach(commVal => {
                    if (commVal == element.value)
                        element.isselected = true;
                })
            });
        }
        if (this.useLastName) {
            this.contactUploadFieldMappings.mapLastName.fieldValue = "";
        }
    }

    removeNullProperties(obj) {
        Object.keys(obj).forEach(key => {
            let value = obj[key];
            if (value === null) {
                delete obj[key];
            }
        });
        return obj;
    }

    getUploadExcelConfig() {
        this.uploadSaveUrl = this.baseUrl + 'api/Contact/Contact_Upload_Excel/' + this.user.cLPCompanyID + '/' + this.user.cLPUserID;
    }

    editField() {
        this.messageStep3 = "Please select the value you would like to add.";
        this.editMode = false;
        this.addTimeout(() => {
            if (!isNullOrUndefined(this.uploadEditFieldForm)) {
                this.uploadEditFieldForm.reset();
                this.uploadEditFieldForm.markAsUntouched();
            }
            this.uploadEditFieldForm = this.prepareUploadEditFieldForm();
        }, 1);
    }

    prepareUploadEditFieldForm() {
        return this.fb.group({
            ddField: new FormControl(""),
            editType: new FormControl(-1),
            textValue: new FormControl("", [Validators.required]),
        });
    }


    async updateContactUploadFormStep3Main() {
        if (this.mySelection.length <= 0) {
            this._notifyService.showWarning('Select Contact Before Save', 'No Contacts Selected');
            return;
        }
        else {
            if (this.uploadEditFieldForm.controls.ddField.value == "Tag" && typeof (this.uploadEditFieldForm.controls.textValue.value) !== 'number' && parseInt(this.uploadEditFieldForm.controls.textValue.value) != 0) {
                await this.addTagByText();
            }
            var uploadContactBulkActionFinal: UploadContactBulkAction = await this.copyValueFromBulkEditToData();
            if (!isNullOrUndefined(this.uploadSessionId))
                this.contactUploadStep3Main(uploadContactBulkActionFinal);
            else
                this._notifyService.showError('Could not upload this step due to Session', 2000);
        }

    }

    async addTagByText() {
        var tagData: TagsFields = <TagsFields>{};
        tagData.cLPCompanyID = this.user?.cLPCompanyID;
        tagData.ownerType = eNoteOwnerType.Contact;
        tagData.tag = this.uploadEditFieldForm.controls.textValue.value;
        tagData.tagID = 0;
        await this._tagSettingService.tagUpdate(this.encryptedUser, tagData)
            .then(async (result: SimpleResponse) => {
                if (result?.messageBool) {
                    this.uploadEditFieldForm.get('textValue').setValue(result.messageInt);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-detail.addNewTag", err.message, tagData,
                    ''
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
    public selectAllState: SelectAllCheckboxState = "unchecked";
    public onSelectedKeysChange(): void {
        const len = this.mySelection.length;

        if (len === 0) {
            this.selectAllState = "unchecked";
        } else if (len > 0 && len < (this.isDuplicateContact ? this.contactDuplicateList.length : this.contactProcessedList.length)) {
            this.selectAllState = "indeterminate";
        } else {
            this.selectAllState = "checked";
        }
    }

    public onSelectAllChange(checkedState: SelectAllCheckboxState): void {
        if (checkedState === "checked") {
            this.mySelection = this.isDuplicateContact ? this.contactDuplicateList.map((item) => item.uploadContactID) : this.contactProcessedList.map((item) => item.uploadContactID);
            this.selectAllState = "checked";
        } else {
            this.mySelection = [];
            this.selectAllState = "unchecked";
        }
    }

    public selectAllCompanyState: SelectAllCheckboxState = "unchecked";
    public onSelectedCompanyKeysChange(): void {
        const len = this.companySelection.length;

        if (len === 0)
            this.selectAllCompanyState = "unchecked";
        else if (len > 0 && len < this.companyProcessedList.length)
            this.selectAllCompanyState = "indeterminate";
        else
            this.selectAllCompanyState = "checked";

    }

    public onSelectAllChangeCompany(checkedState: SelectAllCheckboxState): void {
        if (checkedState === "checked") {
            this.companySelection = this.companyProcessedList.map((item) => item.uploadCompanyID);
            this.selectAllCompanyState = "checked";
        } else {
            this.companySelection = [];
            this.selectAllCompanyState = "unchecked";
        }
    }

    copyValueFromBulkEditToData() {

        var uploadContactBulkActionFinal: UploadContactBulkAction = <UploadContactBulkAction>{};
        uploadContactBulkActionFinal.uploadSessionID = this.uploadSessionId;
        uploadContactBulkActionFinal.uploadContactIdsToProcess = this.processGridType === 1 ? this.mySelection : this.processGridType === 2 ? this.companySelection : [];
        uploadContactBulkActionFinal.isProcessAll = false;
        uploadContactBulkActionFinal.eEdit = +this.uploadEditFieldForm.controls.editType.value;
        uploadContactBulkActionFinal.fieldName = this.uploadEditFieldForm.controls.ddField.value;
        uploadContactBulkActionFinal.fieldvalue = this.uploadEditFieldForm.controls.textValue.value;
        return uploadContactBulkActionFinal;
    }

    async contactUploadStep3Main(uploadContactBulkActionFinal: UploadContactBulkAction) {
        this.showSpinner = true;
        this.buttonTypeOperation = eButtonActions.Save;
        var editBulkContact: number = this.isDuplicateContact ? 1 : 0;
        await this._contactService.uploadContactEditBulk(this.encryptedUser, editBulkContact, uploadContactBulkActionFinal)
            .then(async (result: UploadContactBulkActionResponse) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    this._notifyService.showSuccess(result.messageString, '', 4000);
                    this.showSpinner = false;
                    this.buttonTypeOperation = eButtonActions.None;
                    this.isEditField = false;
                    this.mySelection = [];
                    this.selectAllState = "unchecked"
                    this.companySelection = [];
                    this.saveConfirmation = false;
                    this.uploadEditFieldForm.controls['textValue'].enable();
                    this.messageToShowAfter = res.messageString;
                    this.contactGetListProcessed();
                    this.contactGetListDuplicate();
                    this.companiesListProcessed();
                    this.companiesListDuplicate();
                }
                else {
                    this.buttonTypeOperation = eButtonActions.None;
                    this.showSpinner = false;
                }
                this.isEditField = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    changeField() {
        this.renderConditionalType(this.uploadEditFieldForm.controls.ddField.value, this.uploadEditFieldForm.controls.editType.value)
    }

    renderConditionalType(ddField: any, editType: any) {
        switch (editType) {
            case "0": this.messageStep3 = "Please select the new value.";
            case "1": this.messageStep3 = "Please select the value you would like to add.";
        }
        switch (ddField) {
            case "Shareable": case "Check1": case "Check2": case "Check3": case "Check4": case "Check5": case "Check6":
                this.messageStep3 = "Please select the new value.";
                this.uploadEditFieldForm.controls.textValue.setValue(false);
                break;
            case "Notes": case "Comments":
                break;
            case "CMCustomDate1": case "CMCustomDate2": case "CMCustomDate3": case "CMCustomDate1 : Issue": case "CMCustomDate2 : Request Info": case "CMCustomDate3 : Expiration":
                this.uploadEditFieldForm.controls.textValue.setValue(parseDate(new Date()));
                break;
            case "Class1Code": case "Class1Code : Status":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class1Code.lookup;
                break;
            case "Class2Code": case "Class2Code : Marketing Channel":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class2Code.lookup;
                break;
            case "Class3Code": case "Class3Code : Best time to call":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class3Code.lookup;
                break;
            case "Class4Code": case "Class4Code : DQ/Dead Factors":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class4Code.lookup;
                break;
            case "Class5Code": case "Class5Code : BEM ONLY (do not use)":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class5Code.lookup;
                break;
            case "Class6Code": case "Class6Code : Channel":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class6Code.lookup;
                break;
            case "Class7Code": case "Class7Code : Source":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class7Code.lookup;
                break;
            case "Class8Code": case "Class8Code : Campaign":
                this.classCode = this.contactUploadFieldMapResponse.lookup_Class8Code.lookup;
                break;
            case "Tag":

                this.tagList = this.contactUploadFieldMapResponse.lookUpTags;
                this.tagData = this.tagList?.slice();
                if (editType === "1")
                    this.messageStep3 = "Please select or enter a tag to add";
                break;
        }
    }


    async configureContactList(getDuplicateContactList: number) {
        this.DuplicateContactenum = getDuplicateContactList;
        this.isDuplicateContact = getDuplicateContactList == 1 ? true : getDuplicateContactList == 2 ? true : false;
        if (getDuplicateContactList == 0) {
            await this.contactGetListDuplicate(5, false);
        }
        else if (getDuplicateContactList == 1) {
            await this.contactGetListDuplicate(1, false);
        }
        else if (getDuplicateContactList == 2) {
            await this.contactGetListDuplicate(1, true);
        }

        this.companySelection = [];
        this.mySelection = [];
        this.selectAllState = "unchecked"
        this.isEditField = false;
        this.processGridType = 1;
        this.configuregrid = 1;

    }

    async configureCompanyList(getDuplicateCompanyList: number) {
        this.DuplicateCompanyenum = getDuplicateCompanyList;
        this.isDuplicateCompany = getDuplicateCompanyList == 1 ? true : getDuplicateCompanyList == 2 ? true : false;
        if (getDuplicateCompanyList == 0) {
            await this.companiesListDuplicate(5, true)
        }
        else if (getDuplicateCompanyList == 1) {
            await this.companiesListDuplicate(1, false)
        }
        else if (getDuplicateCompanyList == 2) {
            await this.companiesListDuplicate(1, true)
        }

        this.mySelection = [];
        this.selectAllState = "unchecked"
        this.companySelection = [];
        this.isEditField = false;
        this.processGridType = 2;
        this.configuregrid = 1;

    }

    commonEditTypeForm() {
        this.enumForEditType = eEditType;
        this.editTypeKeys = Object.values(this.enumForEditType).filter(k => !isNaN(Number(k)));
        this.initEditTypeKeys = this.editTypeKeys;
    }

    async contactGetListProcessed() {
        this.showSpinner = true;
        await this._contactService.uploadContactGetListProcessed(this.encryptedUser, this.uploadSessionId, this.user.cLPCompanyID)
            .then(async (result: UploadContactVMResponse) => {
                if (result) {
                    this.uploadContactVMResponse = UtilityService.clone(result);
                    this.totalContactsUploaded = this.uploadContactVMResponse?.uploadContacts?.length
                    this._gridCnfgService.iterateConfigGrid(this.uploadContactVMResponse, "contact_excel_process_grid");
                    this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('contact_excel_process_grid');
                    this.contactProcessedList = this.uploadContactVMResponse.uploadContacts;
                    this.initContactProcessedList = this.contactProcessedList;
                    this.setGrid();
                    this.enumActionToTake = eUploadContactActionToTake;
                    this.getSearchScopeDD();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getSearchScopeDD() {
        this.searchScopeList = [];
        this.searchScopeList.push({ text: 'Entire account', value: 0 }, { text: 'My contacts Only', value: 1 })
        if (this.companyData && this.companyData?.showTeamDD) {
            if (this.user.teamCode > 0)
                this.searchScopeList.push({ text: 'My team only: ' + this.userTeamDisplay, value: 2 })
            if (this.user?.userRole >= eUserRole.Administrator)
                this.searchScopeList.push({ text: 'Select a Team', value: 21 })
        }
        if (this.companyData && this.companyData?.showOfficeDD) {
            if (this.user?.officeCode > 0)
                this.searchScopeList.push({ text: 'My office only: ' + this.userOfficeDisplay, value: 3 })
            if (this.user?.userRole >= eUserRole.Administrator)
                this.searchScopeList.push({ text: 'Select an Office', value: 31 })
        }
    }

    changeDDsearchScope(value) {
        let val: number = value.target.value;
        this.ddDupItems = [];
        if (val == 21) {
            this.isSearchScopeDD = false;
            this.isDupItemsDD = true;
            this.ddDupItems.push({ id: 0, text: '-Select a Team-' }, { id: -1, text: '-Cancel-' })
            this.ddDupItems = this.ddDupItems.concat(this.listTeamCodes);
        }
        else if (val == 31) {
            this.isSearchScopeDD = false;
            this.isDupItemsDD = true;
            this.ddDupItems.push({ id: 0, text: '-Select an Office-' }, { id: -1, text: '-Cancel-' })
            this.ddDupItems = this.ddDupItems.concat(this.listOfficeCodes);
        }
    }

    async contactGetListDuplicate(duplicateFlag: number = 5, isAllUploadOnly: boolean = false) {
        this.showSpinner = true;
        console.log(isAllUploadOnly);
        await this._contactService.uploadContactGetListDuplicate(this.encryptedUser, this.uploadSessionId, this.user.cLPCompanyID, duplicateFlag, isAllUploadOnly)
            .then(async (result: UploadContactVMResponse) => {
                if (result) {
                    this.uploadContactVMResponse = UtilityService.clone(result);
                    this.contactDuplicateList = this.uploadContactVMResponse.uploadContacts;
                    this.initContactDuplicateList = this.contactProcessedList;
                    this.setGrid();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async companiesListProcessed() {
        this.showSpinner = true;
        await this._contactService.uploadCompaniesListProcessed(this.encryptedUser, this.uploadSessionId, this.user.cLPUserID)
            .then(async (result: UploadCompanyRespone) => {
                if (result) {
                    this.uploadCompanyResponse = UtilityService.clone(result);
                    this.companyProcessedList = this.uploadCompanyResponse.uploadCompanies;
                    this.initCompanyProcessedList = this.companyProcessedList;
                    this.setGridCmp();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async companiesListDuplicate(duplicateFlag: number = 5, isAllUploadOnly: boolean = false) {
        this.showSpinner = true;
        await this._contactService.uploadCompaniesDuplicateList(this.encryptedUser, this.uploadSessionId, this.user.cLPUserID, duplicateFlag, isAllUploadOnly)
            .then(async (result: UploadCompanyRespone) => {
                if (result) {
                    this.uploadCompanyResponse = UtilityService.clone(result);
                    this.companyDuplicateList = this.uploadCompanyResponse.uploadCompanies;
                    this.initCompanyDuplicateList = this.companyProcessedList;
                    this.setGridCmp();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
    tranferContact() {
        this.transferConfirmation = true;
        this.tranferStep = 1;
    }
    async transferOwnerShip() {
        var isProcessAll: boolean = false;
        if (this.mySelection.length <= 0) {
            this.transferConfirmation = false;
            this.tranferStep = 0;
            return;
        }
        else {
            this.showSpinner = true;
            await this._contactService.uploadContactTransferOwnerShip(this.encryptedUser, this.uploadSessionId, +this.newManagerId, isProcessAll, this.isDuplicateContact ? 1 : 0, this.mySelection)
                .then(async (result: UploadContactBulkActionResponse) => {
                    if (result) {
                        var res = UtilityService.clone(result);
                        this.messageToShowAfter = res.messageString;
                        this._notifyService.showSuccess(res.messageString, '', 3000);
                        this.isEditField = false;
                        this.mySelection = [];
                        this.selectAllState = "unchecked"
                        this.companySelection = [];
                        this.transferConfirmation = false;
                        this.newManagerId = this.user.cLPUserID.toString();

                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }

    }

    async uploadContactUpdateAction(eUploadAction: number) {
        var isProcessAll: boolean = false;
        console.log(this.contactGetListDuplicate);
        console.log(this.mySelection, 'key select');
        var isFoundDup: boolean = true;


        if (this.processGridType === 1) {
            if (this.mySelection?.length <= 0) {
                this._notifyService.showWarning('Select Contact Before Upload', 'No Contacts Selected');
                return;
            }
            else {
                if (eUploadAction == 1) {
                    if (this.isDuplicateContact) {
                        this.contactDuplicateList.forEach((item) => {
                            let filteredSlectionIdx = this.mySelection.findIndex((x) => x == item?.uploadContactID && item?.dupContactID == 0);
                            if (filteredSlectionIdx != -1) {
                                this.mySelection.splice(filteredSlectionIdx, 1);
                            }
                        })
                    }
                    else {
                        this.contactProcessedList.forEach((item) => {
                            let filteredSlectionIdx = this.mySelection.findIndex((x) => x == item?.uploadContactID && item?.dupContactID == 0);
                            if (filteredSlectionIdx != -1) {
                                this.mySelection.splice(filteredSlectionIdx, 1);
                            }
                        })
                    }
                    if (this.mySelection.length == 0) {
                        this._notifyService.showSuccess('There were no duplicate contacts selected.', '', 3000);
                        return;
                    }
                }
                this.showSpinner = true;
                await this._contactService.uploadContactUpdateAction(this.encryptedUser, this.mySelection, isProcessAll, this.uploadSessionId, this.isDuplicateContact ? 1 : 0, eUploadAction)
                    .then(async (result: UploadContactBulkActionResponse) => {
                        if (result) {
                            var res = UtilityService.clone(result);
                            this._notifyService.showSuccess(res.messageString, '', 3000);
                            this.isEditField = false;
                            this.contactsUploaded.length += this.mySelection?.length;
                            this.mySelection = [];
                            this.selectAllState = "unchecked"
                            this.companySelection = [];
                            this.loadStep4 = true;
                            this.messageToShowAfter = res.messageString;
                            await this.contactGetListProcessed();
                            await this.configureContactList(this.DuplicateContactenum);
                            //await this.contactGetListDuplicate();
                            await this.getLoadSummary(true);
                        }
                        this.showSpinner = false;
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log(err);
                        this.showSpinner = false;
                        this._utilityService.handleErrorResponse(err);
                    });
            }


        }
        else if (this.processGridType === 2) {
            if (this.companySelection?.length <= 0) {
                this._notifyService.showWarning('Select Contact Before Upload', 'No Company Selected');
                return;
            }
            else {
                this.showSpinner = true;
                await this._contactService.uploadCompanyUpdateAction(this.encryptedUser, this.companySelection, isProcessAll, this.uploadSessionId, this.isDuplicateCompany ? 1 : 0, eUploadAction)
                    .then(async (result: UploadComppanyBulkActionResponse) => {
                        if (result) {
                            var res = UtilityService.clone(result);
                            this._notifyService.showSuccess(res.messageString, '', 3000);
                            this.isEditField = false;
                            this.mySelection = [];
                            this.selectAllState = "unchecked"
                            this.companySelection = [];
                            this.loadStep4 = true;
                            this.messageToShowAfter = res.messageString;
                            await this.companiesListProcessed();
                            await this.configureCompanyList(this.DuplicateCompanyenum);
                            //await this.companiesListDuplicate();
                            await this.getLoadSummary(false);
                        }
                        this.showSpinner = false;
                        this.loadStep4 = false;
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log(err);
                        this.showSpinner = false;
                        this.loadStep4 = false;
                        this._utilityService.handleErrorResponse(err);
                    });
            }

        }
        else {
            this._notifyService.showError('No Grid Found', 'Please select a Table', 2000);
        }

    }

    async getLoadSummary(isFromContactGrid: boolean = false) {
        await this._contactService.LoadTempDataSummary(this.encryptedUser, this.uploadSessionId, this.uploadContactSummary.dupCheck, this.user.cLPCompanyID)
            .then(async (result: UploadContactSummary) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    if (isFromContactGrid) {
                        this.uploadContactSummary.totNewCompanies = res.totNewCompanies;
                        this.totCompaniesToUpload = res?.totNewCompanies;
                        this.totContactsToUpload = res?.totNewContacts;
                    }
                    else {
                        this.uploadContactSummary.totNewContacts = res.totNewContacts;
                        this.totContactsToUpload = res?.totNewContacts;
                        this.totCompaniesToUpload = res?.totNewCompanies;
                    }
                    this.checkContactCompany();
                    this.showSpinner = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async dupCheckUploadSummary() {
        if (this.isSearchScopeDD || (this.isDupItemsDD && this.DupItemVal > 0)) {
            this.showSpinner = true;
            this.step4Message = "";
            await this._contactService.runDupCheckWithUploadSummary(this.encryptedUser, this.user.cLPCompanyID, this.uploadSessionId, this.user.cLPUserID, this.searchScope.toString(), this.DupItemVal?.toString(), this.contactUploadForm.controls['cbContactID']?.value)
                .then(async (result: UploadContactSummary) => {
                    if (result) {
                        var res = UtilityService.clone(result);
                        this.uploadContactSummary = res;
                        this.totContactsToUpload = this.uploadContactSummary?.totNewContacts;
                        this.totCompaniesToUpload = this.uploadContactSummary?.totNewCompanies;
                        this.isFindDuplicate = false;
                        this.checkContactCompany();


                        this.contactGetListProcessed();
                        this.companiesListProcessed();
                        this.companiesListDuplicate();
                        this.contactGetListDuplicate();
                        this.showSpinner = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            if (this.isDupItemsDD && this.DupItemVal == 0) {
                this._notifyService.showWarning('Please select an item.', 3000);
            }
            else if (this.isDupItemsDD && this.DupItemVal == -1) {
                this.isSearchScopeDD = true;
                this.isDupItemsDD = false;
                this.searchScope = 0;
                this.step4Message = "Please select the scope for duplicate detection.";
            }
        }
    }

    checkContactCompany() {
        if (!isNullOrUndefined(this.uploadContactSummary.totDuplicateContacts)) {
            const totalContacts = Number(this.uploadContactSummary.totDuplicateContacts.replace(/,/g, ''));
            if (+totalContacts > 0)
                this.isShowContactDuplicatebtn = true;
        }

        if (!isNullOrUndefined(this.uploadContactSummary.totDupCompanies)) {
            const totalCompanies = Number(this.uploadContactSummary.totDupCompanies.replace(/,/g, ''));
            if (+totalCompanies > 0)
                this.isShowCompaniesDuplicatebtn = true;
        }
    }

    async contactUploadGetMoreFilters() {
        this.showSpinner = true;
        await this._contactService.contactUploadGetMoreFilters(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: ContactUploadMoreFilters) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    this.filterManagerTransfer = res.filter_Manager;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async excelStep4Load() {
        //if (!this.loadStep4) {
        //  this._notifyService.showWarning('There are no items to upload.', 'Select Items');
        //}
        //else {
        this.buttonTypeOperation = eButtonActions.Save;
        this.disableBtn = true;
        await this._contactService.uploadContactProcessStep4Load(this.encryptedUser, this.uploadSessionId, this.user.cLPCompanyID)
            .then(async (result: ProcessStep2Resonse) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    this.uploadContactSummary = res.uploadContactSummary;
                    this.totContactsToUpload = this.uploadContactSummary?.totNewContacts;
                    this.totCompaniesToUpload = this.uploadContactSummary?.totNewCompanies;
                    this.step = 4;
                    this.loadStep4 = false;
                }
                this.disableBtn = false;
                this.buttonTypeOperation = eButtonActions.None;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.disableBtn = false;
                this.buttonTypeOperation = eButtonActions.None;
                this._utilityService.handleErrorResponse(err);
            });
        /*}*/
    }

    async step4Upload() {
        this.disableBtn = true;
        this.buttonTypeOperation = eButtonActions.Save;
        await this._contactService.processStep4UploadContacts(this.encryptedUser, this.uploadSessionId, this.user.cLPCompanyID, this.uploadMappingID, this.user.cLPUserID, this.ddOptinText, this.ddSubscribeEmail, this.contactUploadForm.controls['mapNotes']?.value != "" ? +this.contactUploadForm.controls['mapNotes']?.value : 0)
            .then(async (result: ProcessStep2Resonse) => {
                if (result) {
                    var res = UtilityService.clone(result);
                    //this._notifyService.showSuccess('Congratulations. Your data has been uploaded successfully.', 'Congratulations!', 3000);
                    this.step4Complete = true;
                    this.contactsUploaded = [];
                }
                this.disableBtn = false;
                this.buttonTypeOperation = eButtonActions.None;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.disableBtn = false;
                this.buttonTypeOperation = eButtonActions.None;
                this.step4Complete = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    /* grid*/

    onContactProcessListFilter(inputValue: string): void {

        inputValue = inputValue.trim().toLowerCase();

        if (this.contactSource) {
            this.contactSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.contactSource.filter = inputValue;
        }
    }

    onCompanyProcessListFilter(inputValue: string): void {
        inputValue = inputValue.trim().toLowerCase();

        if (this.companySource) {
            this.companySource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.companySource.filter = inputValue;
        }
    }
    /* grid*/

    handleTagFilter(value) {
        this.tagData = this.tagList.filter(
            (s) => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    changeDDFields() {
        this.editMode = true;
        switch (this.uploadEditFieldForm.controls.ddField.value) {
            case "Shareable": case "Class1Code": case "Class2Code": case "Class3Code": case "Class4Code": case "Class5Code": case "Class6Code": case "Class1Code : Status": case "Class2Code : Marketing Channel": case "Class3Code : Best time to call": case "Class4Code : DQ/Dead Factors": case "Class5Code : BEM ONLY (do not use)": case "Class6Code: Channel": case "Class7Code : Source": case "Class8Code : Campaign":
                this.editTypeKeys = this.initEditTypeKeys.filter(value => value != 1);
                break;
            case 'Tag':
                this.editTypeKeys = this.initEditTypeKeys.filter(value => value == 1);
                break;
            default:
                this.editTypeKeys = this.initEditTypeKeys.filter((value: any) => value <= 2);
                break;

        }
    }

    getClassificationData(classifcation: any[]) {
        var strClassification = "";
        if (!isNullOrUndefined(classifcation)) {
            classifcation.forEach(value => {
                strClassification = '<p>' + value + '</p>' + strClassification;
            })
            return strClassification;
        }
    }

    getActionToTakeData(value: number): string {
        return this.enumActionToTake[value] ? this.enumActionToTake[value] : "";
    }

   

    cancelTransfer() {
        this.isEditField = false;
        this.transferConfirmation = false;
        this.mySelection = [];
        this.selectAllState = "unchecked"
        this.newManagerId = this.user.cLPUserID.toString();
    }
    cancelSaveContact() {
        this.isEditField = false;
        this.saveConfirmation = false;
        this.uploadEditFieldForm.controls['textValue'].enable();
    }

    preTransferContact() {
        if (!isNullOrUndefined(+this.newManagerId)) {
            if (+this.newManagerId == 0) {
                this.transferConfirmation = true;
                return;
            }
            else {
                this.warningMsg = 'You are about to transfer ownership of all ' + this.mySelection.length.toString() + ' selected contacts to ' + this.filterManagerTransfer.filter(x => x.value == this.newManagerId)[0]?.text.toString() + ' Please confirm.';
                this.tranferStep = 2;
                this.transferConfirmation = true;
            }
        }
    }

    preSaveContact() {
        if (this.mySelection?.length <= 0) {
            this._notifyService.showWarning('Select atleast one contact before transfer', 'No Contact Selected');
            return;
        }
        else {
            if (this.uploadEditFieldForm.controls.textValue.value == "")
                this.uploadEditFieldForm.controls.textValue.markAsTouched();
            else {
                this.saveConfirmation = true;
                this.uploadEditFieldForm.controls['textValue'].disable();
            }

        }
    }

    getDuplicatesOnly() {
        return this.uploadContactSummary?.totDuplicateContacts != null && +this.uploadContactSummary?.totDuplicateContacts > 0;
    }

    getHtmlExcel(systemData) {
        if (!isNullOrUndefined(systemData)) {
            return this._sanitizer.sanitize(SecurityContext.HTML, systemData);
        }
    }
    async getCompanyByCompanyId() {
        this.companyData = await this._localService.loadCompany();
        if (this.companyData == null) {
            await this._accountSetupService.getClpCompany(this.encryptedUser, this.user?.cLPCompanyID)
                .then(async (result: CompanyResponse) => {
                    if (!isNullOrUndefined(result))
                        this.companyData = UtilityService.clone(result?.company);
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("contact-upload-excel.getCompanyByCompanyId", err.message, null,
                        'cLPCompanyID: ' + this.user?.cLPCompanyID
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async uploadMapping_Delete(uploadMappingID) {
        await this._contactService.uploadMapping_Delete(this.encryptedUser, uploadMappingID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        let idx = this.lookUpExistingMappings.findIndex((item) => item?.value == uploadMappingID);
                        if (idx != -1) {
                            this.lookUpExistingMappings.splice(idx, 1);
                        }
                        this.recentUpload = 0;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-upload-excel.getCompanyByCompanyId", err.message, null,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async selectedTagChangeEvent(tag: string = "") {
        if (parseInt(tag) > 0) {
            let tagData = this.tagList?.filter(x => parseInt(x.value) == parseInt(tag))[0].value;
            this.uploadEditFieldForm.get('textValue').setValue(tagData);
        } else {
            this.uploadEditFieldForm.get('textValue').setValue(tag);
        }
    }
    setGrid() {
        this.contactDisplayColumns = this.columns.map(c => c.field);

        this.masterList = this.isDuplicateContact
            ? this.contactDuplicateList
            : this.contactProcessedList;

        this.contactSource = new MatTableDataSource<UploadContactVM>();

        this.addTimeout(() => {
            if (!this.paginator) return;

            this.paginator.length = this.masterList.length;

            const pageSize =
                this._localService.getPageSize('contact_excel_process_grid') ?? 50;
            this.paginator.pageSize = pageSize;

            this.contactSource.data = this.masterList.slice(0, pageSize);

            if (this.sort) {
                this.contactSource.sort = this.sort;
                const sortState: Sort =
                    this._localService.getSortState('contact_excel_process_grid');
                if (sortState) {
                    this.sort.active = sortState.active;
                    this.sort.direction = sortState.direction;
                    this.sort.sortChange.emit(sortState);
                }
            }

            this.paginator.page.subscribe((e: PageEvent) => {
                const start = e.pageIndex * e.pageSize;
                const end = start + e.pageSize;
                this.contactSource.data = this.masterList.slice(start, end);
            });
        }, 0)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    toggleSelection(row) {
        const index = this.mySelection.findIndex(r => r == row.uploadContactID);
        if (index >= 0) {
            this.mySelection.splice(index, 1);
        } else {
            this.mySelection.push(row.uploadContactID);
        }
    }

    isSelected(row): boolean {
        return this.mySelection.includes(row.uploadContactID);
    }

    toggleSelectAll(event: any) {
        if (event.checked) {
            this.mySelection = this.isDuplicateContact ? this.contactDuplicateList.map((item) => item.uploadContactID) : this.contactProcessedList.map((item) => item.uploadContactID);
        } else {
            this.mySelection = [];
        }
    }

    isAllSelected(): boolean {
        if (this.mySelection && this.contactSource) {
            return this.mySelection.length == this.contactSource.data.length;
        }
        return false;
    }

    isIndeterminate(): boolean {
        return this.mySelection.length > 0 && !this.isAllSelected();
    }




    setGridCmp() {

        this.companyDisplayColumns = this.columnsCmp.map(c => c.field);

        if (this.isDuplicateCompany) {
            this.companySource = new MatTableDataSource(this.companyDuplicateList);
        }
        else {
            this.companySource = new MatTableDataSource(this.companyProcessedList);

        }
        this.addTimeout(() => {
            this.companySource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('company_excel_process_grid') ? this._localService.getPageSize('company_excel_process_grid') : 50;
            }
            if (this.sort) {
                this.companySource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('company_excel_process_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500);
    }

    toggleSelectionCmp(row) {
        const index = this.companySelection.findIndex(r => r == row.uploadCompanyID);
        if (index >= 0) {
            this.companySelection.splice(index, 1);
        } else {
            this.companySelection.push(row.uploadCompanyID);
        }
    }

    isSelectedCmp(row): boolean {
        return this.companySelection.includes(row.uploadCompanyID);
    }

    toggleSelectAllCmp(event: any) {
        if (event.checked) {
            this.companySelection = this.companyProcessedList.map((item) => item.uploadCompanyID);
        } else {
            this.companySelection = [];
        }
    }

    isAllSelectedCmp(): boolean {
        if (this.companySelection && this.companySource) {
            return this.companySelection.length == this.companySource.data.length;
        }
        return false;
    }

    isIndeterminateCmp(): boolean {
        return this.companySelection.length > 0 && !this.isAllSelectedCmp();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();

        this.intervals.forEach(id => clearInterval(id));
        this.intervals.clear();
    }

    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }
}
